function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 12.66395,14.330242 c 0,0.183292 -0.149966,0.333258 -0.333258,0.333258 H 3.6659758 c -0.1832921,0 -0.3332583,-0.149966 -0.3332583,-0.333258 0,-0.183292 0.1499662,-0.333259 0.3332583,-0.333259 h 3.925783 L 6.4953389,12.900564 c -0.1299707,-0.129971 -0.1299707,-0.339924 0,-0.469895 0.1299707,-0.129971 0.3399235,-0.129971 0.4698942,0 l 0.6998425,0.699843 V 2.7961714 L 6.9785635,3.559333 c -0.066652,0.073317 -0.1566314,0.1099752 -0.2466112,0.1099752 -0.079982,0 -0.159964,-0.026661 -0.2232831,-0.086647 C 6.3720333,3.4593555 6.3620356,3.2494027 6.4853412,3.1127668 L 7.4884487,2.0030166 H 3.6693084 c -0.1832921,0 -0.3332583,-0.1499662 -0.3332583,-0.3332583 0,-0.1832921 0.1499662,-0.3332583 0.3332583,-0.3332583 h 8.6647166 c 0.183292,0 0.333257,0.1499662 0.333257,0.3332583 0,0.1832921 -0.149965,0.3332583 -0.333257,0.3332583 H 8.4082416 l 1.0964199,1.0964199 c 0.1299707,0.1299707 0.1299707,0.3399235 0,0.4698942 -0.1299708,0.1299707 -0.3399235,0.1299707 -0.4698942,0 L 8.3349248,2.8694883 V 13.203829 l 0.6865121,-0.763162 c 0.1233056,-0.136636 0.3332583,-0.146634 0.4698943,-0.02333 0.1366359,0.123305 0.1466336,0.333258 0.023328,0.469894 l -1.0031075,1.10975 h 3.8191403 c 0.183292,0 0.333258,0.149967 0.333258,0.333259 z",
    id: "path1",
    style: {
      strokeWidth: 0.666517
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementVertical);
export default __webpack_public_path__ + "static/media/measurementVertical.4c8ce0d478ad51a91fb7d879491b6d2b.svg";
export { ForwardRef as ReactComponent };